import { render, staticRenderFns } from "./TqTextareaAutosize.vue?vue&type=template&id=26120b12&scoped=true&"
import script from "./TqTextareaAutosize.vue?vue&type=script&lang=js&"
export * from "./TqTextareaAutosize.vue?vue&type=script&lang=js&"
import style0 from "./TqTextareaAutosize.vue?vue&type=style&index=0&id=26120b12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26120b12",
  null
  
)

export default component.exports